import { getLabel } from 'developer-docs-source/labels/index';
import Alert from 'developer-docs-mdx-components/components/Alert';
// @ts-expect-error No types given for file
import Markdown from 'developer-docs-shared-components/modules/Doc/components/Markdown';
import { NewVersionUnderDevelopment, PrivateBetaAvailable, PublicBeta } from 'developer-docs-mdx-components/utils/staticAlerts';
import { LinkWithEnglishSuperset } from 'developer-docs-shared-components/components/Link';
import ResponsiveRenderer from 'developer-docs-shared-components/components/ResponsiveRenderer';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMemo } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { useViewport } from 'developer-docs-shared-components/hooks/useViewport';
import useLocale from 'developer-docs-shared-components/hooks/useLocale';
import { isUrlLocalized } from '../../utils/localization';
import { getEnglishBaseUrl } from '../../utils/urls';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIList from 'UIComponents/list/UIList';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { useGetBreadcrumbsByUrl } from '../../hooks/useGetBreadcrumbsByUrl';
import DocsBreadcrumbs from '../DocsBreadcrumbs';
import APIHeaderCard from './APIHeaderCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const APIHeader = ({
  apiKey,
  selectedVersion,
  setSwitchToc,
  versions
}) => {
  var _selectedVersion$intr2;
  const title = getLabel(apiKey) || '';
  const {
    isMobile
  } = useViewport();
  const locale = useLocale();
  const breadcrumbs = useGetBreadcrumbsByUrl({
    title
  });
  const publicApiSpecAlert = useMemo(() => {
    if (selectedVersion && !selectedVersion.isLegacy) {
      var _selectedVersion$intr;
      switch ((_selectedVersion$intr = selectedVersion.introContent) === null || _selectedVersion$intr === void 0 ? void 0 : _selectedVersion$intr.documentationBanner) {
        case 'NEW_VERSION':
          {
            return /*#__PURE__*/_jsx(NewVersionUnderDevelopment, {});
          }
        case 'PRIVATE_BETA':
          {
            return /*#__PURE__*/_jsx(PrivateBetaAvailable, {});
          }
        case 'PUBLIC_BETA':
          {
            return /*#__PURE__*/_jsx(PublicBeta, {});
          }
        default:
          {
            return undefined;
          }
      }
    }
    return undefined;
  }, [selectedVersion]);
  return /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsxs(View, {
      marginBlockEnd: !isMobile ? '500' : '0',
      children: [breadcrumbs && /*#__PURE__*/_jsx(DocsBreadcrumbs, {
        breadcrumbs: breadcrumbs
      }), /*#__PURE__*/_jsxs(Flex, {
        marginBlockEnd: "400",
        justifyContent: "space-between",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h1",
          typography: "heading-600",
          marginBlockStart: !isMobile ? '200' : '0',
          children: title
        }), /*#__PURE__*/_jsxs(ButtonWrapper, {
          children: [selectedVersion && /*#__PURE__*/_jsx(UITooltip, {
            disabled: versions.length > 1,
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "developer-docs-ui.apiReference.onlyOneVersion",
              options: {
                version: versions[0].versionName
              }
            }),
            children: /*#__PURE__*/_jsx(UIDropdown, {
              buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "developer-docs-ui.apiReference.selectedVersion",
                options: {
                  version: selectedVersion.versionName
                }
              }),
              buttonSize: "small",
              buttonUse: "tertiary-light",
              disabled: versions.length === 1,
              children: /*#__PURE__*/_jsx(UIList, {
                children: versions.map(version => {
                  const absolutePath = `${apiKey}/${version.versionName}`;
                  const isLocalized = isUrlLocalized(absolutePath, locale);
                  const isSelectedVersion = version.versionName === selectedVersion.versionName;
                  return /*#__PURE__*/_jsx(UITooltip, {
                    disabled: !isSelectedVersion,
                    title: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "developer-docs-ui.apiReference.versionAlreadySelected",
                      options: {
                        version: version.versionName
                      }
                    }),
                    children: !isLocalized ?
                    /*#__PURE__*/
                    // External link pointing to en-us version
                    _jsx(LinkWithEnglishSuperset, {
                      hrefLang: isSelectedVersion ? '' : 'en-us',
                      external: !isSelectedVersion,
                      href: getEnglishBaseUrl(absolutePath),
                      disabled: isSelectedVersion,
                      onClick: () => setSwitchToc(true),
                      children: version.versionName
                    }) :
                    /*#__PURE__*/
                    // Router-aware link within the same localized site
                    _jsx(UIRouterLink, {
                      to: absolutePath,
                      disabled: isSelectedVersion,
                      onClick: () => setSwitchToc(true),
                      children: version.versionName
                    })
                  }, version.versionName);
                })
              })
            })
          }), selectedVersion && !selectedVersion.isLegacy && ((_selectedVersion$intr2 = selectedVersion.introContent) === null || _selectedVersion$intr2 === void 0 ? void 0 : _selectedVersion$intr2.postmanCollectionId) && /*#__PURE__*/_jsx(ResponsiveRenderer, {
            renderMobile: () => null,
            renderDesktop: () => {
              var _selectedVersion$intr3;
              return /*#__PURE__*/_jsx(FormattedJSXMessage, {
                message: "developer-docs-ui.apiReference.runInPostmanLink_jsx",
                elements: {
                  Button
                },
                options: {
                  use: 'tertiary',
                  // TODO: For localization, should we use different locale-specific Postman URLs, if available?
                  href: `https://app.getpostman.com/run-collection/${(_selectedVersion$intr3 = selectedVersion.introContent) === null || _selectedVersion$intr3 === void 0 ? void 0 : _selectedVersion$intr3.postmanCollectionId}`,
                  external: true,
                  size: 'small'
                }
              });
            }
          })]
        })]
      })]
    }), publicApiSpecAlert || (selectedVersion && selectedVersion.isLegacy ? /*#__PURE__*/_jsx(Alert, {
      type: selectedVersion.alert.type,
      children: /*#__PURE__*/_jsx(Markdown, {
        children: selectedVersion.alert.text
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {})), selectedVersion && /*#__PURE__*/_jsx(APIHeaderCard, {
      version: selectedVersion
    })]
  });
};
export default APIHeader;